import React from "react";
import Request from "./Request";
import HowItWorks from "./HowItWorks";
import PriceList from "./PriceList";
import SampleSickNote from "./SampleSickNote";

import FAQ from "./FAQ";

const SickNoteArea = () => {
  return (
    <>
      <section id="sicknote-area">
        <div className="container">
          <Request />
          <HowItWorks />
          <PriceList />
          <SampleSickNote />
          <FAQ />
        </div>
      </section>
    </>
  );
};

export default SickNoteArea;
